import React, { Suspense, useEffect, useRef, useState } from "react"
import { updatePasswordData } from "./data/ResetPasswordForm.data";
import FormCreator from "../../components/forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import {
    useResetPasswordForWebMemberMutation
} from "../../app/services/AdmissionBoardApproval/AdmissionBoardServiceApi";
import PageLoader from "../../components/ui/pageLoader/PageLoader";
import SwalAlert from "../../services/swalService/SwalService";
import { UrlIdDecrypt } from "../../utils/Encryption";
import { useParams } from 'react-router-dom';

const UpdatePasswordForm = () => {
    const params = useParams();
    const updateFormRef = useRef();
    const [formData, setFormData] = useState(updatePasswordData);
    const { error, success } = SwalAlert();
    const [updatePassword, { isLoading: isLoading, isSuccess: isSuccess, data: updatePasswordRes }] = useResetPasswordForWebMemberMutation();

    useEffect(() => {
        if (!isLoading && isSuccess && updatePasswordRes) {
            success("Your password has been changed successfully. Use your new password to log in.");
        }
    }, [isLoading, isSuccess, updatePasswordRes]);

    const handleUpdatePassword = () => {
        const formData = updateFormRef.current?.getFormData();
        if (!formData) return;
        if (formData?.password === formData?.confirmPassword) {
            const paramsquery = params["*"].split("/");
            if (paramsquery[0] === "member") {
                const request = {
                    IPASMemberId: UrlIdDecrypt(paramsquery[1]),
                    Password: formData.password || null,
                    EmailAddress: null,
                    AdminId: 0,
                    RoleId: 0
                };
                updatePassword(request);
            }
            else if (paramsquery[0] === "committee") {
                const request = {
                    IPASMemberId: 0,
                    Password: formData.password || null,
                    EmailAddress: UrlIdDecrypt(paramsquery[3]),
                    AdminId: UrlIdDecrypt(paramsquery[1]),
                    RoleId: UrlIdDecrypt(paramsquery[2]),
                    Name: UrlIdDecrypt(paramsquery[4])
                };
                updatePassword(request);
            }
        } else {
            error("The passwords do not match. Please try again.", "");
        }
    }

    return (

        <div className='container resetPasswordForm'>
            <div className='row d-flex justify-content-center'>
                <div className='col-lg-6 resetPasswordCard py-4 my-5'>
                    <h1 className='text-center'>Update Password</h1>
                    <h6 className='text-center'>Enter new password to retrieve your account</h6>
                    <hr />
                    <div className='p-4'>
                        <p class="lead">Password must be at least 6 alphanumeric characters and contain at least one uppercase, one special character such as @#$%</p>
                        <Suspense fallback={<PageLoader />}>
                            <FormCreator
                                ref={updateFormRef}
                                config={formData}
                            />
                            <div className='col-lg-12 mt-3'>
                                <Buttons
                                    buttonTypeClassName="btn success-btn"
                                    buttonText="Reset Your Password"
                                    onClick={handleUpdatePassword}
                                    isLoading={isLoading}
                                />
                            </div>
                        </Suspense>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default UpdatePasswordForm;
